export default "__VITE_ASSET__6a9d6e21__"